import {
  AppVariation,
  type ClientConfig,
} from "src/client-config/getClientConfig.ts";
import {
  getB2bgateModules,
  getB2bgateForSupplierModules,
  getErpModules,
} from "src/admin/modules.ts";
import type { Module } from "src/system/module.types.ts";

export const getModules = (config: ClientConfig): Module[] => {
  if (config.appVariation === AppVariation.Erp) {
    return getErpModules();
  }
  if (config.appVariation === AppVariation.B2bGateSupplier) {
    return getB2bgateForSupplierModules();
  }
  if (config.appVariation === AppVariation.B2bGate) {
    return getB2bgateModules();
  }
  return [];
};
